module.exports = __webpack_public_path__ + "img/online-consultation.3f8a3111.svg";